import { render, staticRenderFns } from "./xiaohei_order_check_edit.vue?vue&type=template&id=67c44be0&scoped=true"
import script from "./xiaohei_order_check_edit.vue?vue&type=script&lang=js"
export * from "./xiaohei_order_check_edit.vue?vue&type=script&lang=js"
import style0 from "./xiaohei_order_check_edit.vue?vue&type=style&index=0&id=67c44be0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c44be0",
  null
  
)

export default component.exports